import type { LabelTemplate } from '@trackeat/shared';

/** Synthetic data only: the test does not create HACCP events or consume stock. */
export function printerTestTemplate(): LabelTemplate {
  return {
    id: 'y428bt-test', tenant_id: '', business_id: null,
    name: 'Prova Y428BT', preset: 'lavorato', width_mm: 50, height_mm: 30,
    required_allergens: false, version: 1,
    created_at: '2026-09-15T00:00:00Z', archived_at: null,
    elements: [
      { id: 'title', type: 'text', x_mm: 2, y_mm: 2, rotation: 0,
        font_size_pt: 9, font_weight: 'bold', static_value: 'TRACKEAT · PROVA' },
      { id: 'accents', type: 'text', x_mm: 2, y_mm: 7, rotation: 0,
        font_size_pt: 7, static_value: 'Caffè, qualità, più' },
      { id: 'square', type: 'rect', x_mm: 2, y_mm: 12, rotation: 0,
        width_mm: 10, height_mm: 10 },
      { id: 'square-label', type: 'text', x_mm: 14, y_mm: 15, rotation: 0,
        font_size_pt: 6, static_value: '10 × 10 mm' },
      { id: 'qr', type: 'qr', x_mm: 31, y_mm: 10, rotation: 0,
        width_mm: 15, height_mm: 15, static_value: 'TRACKEAT-Y428BT-TEST' },
      { id: 'footer', type: 'text', x_mm: 2, y_mm: 26, rotation: 0,
        font_size_pt: 6, static_value: '300 dpi · 50 × 30 mm · SOLO TEST' },
    ],
  };
}
